<template>
  <!-- 新增管理员   -->
  <div class="addAdmin">
    <el-card shadow="never" style="height: 580px">
      <h3>{{$route.query.type == 'edit' ? '编辑管理员':'新增管理员'}}</h3>
      <el-form :model="form" :rules="rules">
        <el-form-item label="姓名：" :label-width="formLabelWidth" prop="name">
          <el-input
            placeholder="请输入计划名称"
            v-model="form.name"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="手机号："
          :label-width="formLabelWidth"
          prop="name"
        >
          <el-input
            placeholder="请输入手机号"
            v-model="form.name2"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="密码：" :label-width="formLabelWidth" prop="name">
          <el-input
            placeholder="请输入密码"
            v-model="form.name3"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="邮箱：" :label-width="formLabelWidth">
          <el-input
            placeholder="请输入邮箱号"
            v-model="form.name4"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="管理组："
          :label-width="formLabelWidth"
          prop="name"
        >
          <el-select
            v-model="form.region"
            placeholder="请选择管理员"
            value="超级管理员"
          >
            <el-option label="超级管理员" value="超级管理员"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card shadow="never">
      <el-button @click="cancel" round>取 消</el-button>
      <el-button type="primary" round @click="yes">确 定</el-button>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        name: "",
        name2: "",
        name3: "",
        name4: "",
        region: "超级管理员",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: "",
      },
      formLabelWidth: "120px",
      rules: {
        name: [{ required: true, message: "请输入", trigger: "blur" }],
      },
    };
  },
  methods:{
    cancel(){
      //点击取消跳回管理员设置
      this.$router.push({name:'permissionSet',query:{t:2}})
    },
    yes(){
        //点击取消跳回管理员设置
      this.$router.push({name:'permissionSet',query:{t:2}})
         this.$message({
          showClose: true,
          message: '恭喜你，新增管理员成功',
          type: 'success'
        });
    }
  }
};
</script>

<style lang='less'>
.addAdmin {
  padding: 20px;
  h3 {
    font-size: 16px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #33393f;
  }
  .el-form {
    margin-top: 39px;
  }
  .el-input__inner {
    width: 424px;
    height: 32px;
    background: #f6f6f6;
    border-radius: 16px;
  }
  .el-form-item__label {
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #666;
    transform: translate(0px, 2px);
  }
}
</style>